import getConfig from "next/config"
const { publicRuntimeConfig = {} } = getConfig() ?? {}

export const REDIRECT_TIMEOUT = 1000

export const API_URL = publicRuntimeConfig.NEXT_PUBLIC_API_URL
export const GOOGLE_ANALYTICS_LINK = "https://support.google.com/analytics/answer/6367342"
export const HR_APP_URL = publicRuntimeConfig.NEXT_PUBLIC_HR_APP_URL
export const CANDIDATE_SOLUTION_ATTEMPT_DURATION_IN_MINUTES = 15
